import { Reducer } from 'redux';

import { Action, createAction } from '../../../store/actionUtils';

export interface Show {
    id: string;
    poster: string;
    title: string;
    url: string;
}

export enum ShowsActionTypes {
    RECEIVE_SHOWS = 'ShowsIndex/shows/RECEIVE_SHOWS',
}

export type ReceiveShowsAction = Action<ShowsActionTypes.RECEIVE_SHOWS, Show[]>;

const showsReducer: Reducer<Show[], ReceiveShowsAction> = (state = [], action) => {
    switch (action.type) {
        case ShowsActionTypes.RECEIVE_SHOWS:
            return action.payload;
        default:
           return state;
    }
};

// Action creators
export const receiveShows = createAction<ReceiveShowsAction>(
    ShowsActionTypes.RECEIVE_SHOWS,
    doc => (doc.shows as any[]).reduce<Show[]>((acc, row, i) => {
        switch (row._group) {
            case 'show':
                return [...acc, {
                    id: row.show_collection.id,
                    poster: row.show_image.replace(/^http:/, ''),
                    title: row.show_collection.title,
                    url: `/videos/${row.show_collection.slug}`,
                }];
            case 'other':
                return [...acc, {
                    id: `_other_${i}_`,
                    poster: row.other_image.replace(/^http:/, ''),
                    title: row.other_link.value,
                    url: row.other_link.href,
                }];
            default:
                return acc;
        }
    }, []),
);

export default showsReducer;
